import React from 'react';
import { Link } from 'react-router-dom';

function Blogs() {
  const blogs = [
    {
      id: 1,
      category: 'Entrepreneurship',
      title: 'Reflections from the 7th Africa’s Business Heroes Finale',
      excerpt: 'The 7th Africa’s Business Heroes finale was an inspiring experience that highlighted innovation, resilience, and the power of entrepreneurship to solve social and economic challenges across Africa.',
      date: '26 April 2026',
      readTime: '7 min read',
      image: '/dm4.jpeg',
    },
    {
      id: 3,
      category: 'Web Development',
      title: 'Why React Is Built for Performance and Scale',
      excerpt: "Modern web development demands performance, scalability, and user-centered design. Here's how React enables all three through components, virtual DOM rendering, and a powerful ecosystem.",
      date: '26 April 2026',
      readTime: '7 min read',
      image: '/ajang4.jpeg',
    },
    {
      id: 2,
      category: 'Leadership',
      title: 'Service Over Status: A Practical View of True Leadership',
      excerpt: 'True leadership means listening, adapting, and uplifting others. Learn why service-oriented leadership creates trust, empowers teams, and drives lasting impact.',
      date: '17 April 2026',
      readTime: '5 min read',
      image: '/md.jpg',
    },
  ];

  return (
    <div className="page-wrapper">

      {/* Hero */}
      <section className="bl-hero">
        <div className="bl-hero-overlay"></div>
        <div className="bl-hero-content">
          <span className="insights-label" style={{color:'#29abe2'}}>My Blog</span>
          <h1 className="bl-hero-title">Thoughts &amp; Insights</h1>
          <p className="bl-hero-sub">Experiences, reflections, and ideas worth sharing</p>
        </div>
      </section>

      {/* Blog grid */}
      <section className="bl-section">
        <div className="bl-container">
          <div className="bl-header">
            <span className="insights-label">Latest Posts</span>
            <h2 className="insights-heading">Recent Articles</h2>
          </div>
          <div className="bl-grid">
            {blogs.map(blog => (
              <article key={blog.id} className="bl-card">
                <Link to={`/blog/${blog.id}`} className="bl-card-img-wrap">
                  <img src={blog.image} alt={blog.title} className="bl-card-img" />
                  <span className="bl-card-category">{blog.category}</span>
                </Link>
                <div className="bl-card-body">
                  <div className="bl-card-meta">
                    <span>
                      <svg width="13" height="13" fill="#9ca3af" viewBox="0 0 24 24" style={{marginRight:'4px',verticalAlign:'middle'}}><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"/></svg>
                      {blog.date}
                    </span>
                    <span>
                      <svg width="13" height="13" fill="#9ca3af" viewBox="0 0 24 24" style={{marginRight:'4px',verticalAlign:'middle'}}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>
                      {blog.readTime}
                    </span>
                  </div>
                  <h2 className="bl-card-title">{blog.title}</h2>
                  <p className="bl-card-excerpt">{blog.excerpt}</p>
                  <Link to={`/blog/${blog.id}`} className="bl-card-link">
                    Read More
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" style={{marginLeft:'5px'}}><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}

export default Blogs;
